import {
    Component,
    ComponentFactoryResolver,
    ElementRef, HostListener,
    Input,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subscription } from 'rxjs/index';
import { filter, map } from 'rxjs/operators';
import * as X2JS from 'x2js';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { AudioService } from '../services/audio.service';
import { PersonMessageService } from './person-message.service';

@Component({
    selector: 'message-display-dialog',
    templateUrl: './message-display-dialog.component.html'
})
export class MessageDisplayDialogComponent implements OnInit {
    @Input() messageUuid: string;
    @Input() mediaType: string;
    @Input() isTrackingcode: boolean;
    @Input() messageType: string;

    @ViewChild('emailIFrame') iframe: ElementRef;

    messageContent$: Observable<any>;
    isAuthenticatedFromAdmin$: Observable<boolean>;
    loaded = false;
    messages = [];
    innerHtml = '';
    subscriptions: Subscription = new Subscription();
    isPreview = true;
    contentSource: any;
    isAuthenticatedFromAdmin = false;

    constructor(private vcRef: ViewContainerRef,
                private resolver: ComponentFactoryResolver,
                private messageService: PersonMessageService,
                private authenticationSelectors: AuthenticationSelectors,
                private bsModalRef: BsModalRef) {
        this.isAuthenticatedFromAdmin$ = this.authenticationSelectors.selectIsAuthenticatedFromAdmin()
            .pipe(
                filter(isAuthenticatedFromAdmin => isAuthenticatedFromAdmin !== undefined),
                map(isAuthenticatedFromAdmin => this.isAuthenticatedFromAdmin = isAuthenticatedFromAdmin)
            );
    }

    ngOnInit(): void {
        if (this.isTrackingcode) {
            this.messageContent$ = this.messageService.getMessageContentByTrackingCode(this.messageUuid, this.mediaType, this.messageType)
                .pipe(
                    map(messageData => {
                        this.loaded = true; // TODO: Refactor to avoid side-effect

                        return this.getJson(messageData);
                    })
                );
        } else {
            this.messageContent$ = this.messageService.getMessageContentByMessageUuid(this.messageUuid, this.mediaType, this.messageType)
                .pipe(
                    map(messageData => {
                        this.loaded = true; // TODO: Refactor to avoid side-effect

                        return this.getJson(messageData);
                    })
                );
        }
        // TODO: On error loading - just display error message in dialog and let user close and click on message icon again later
    }

    public onClose(): void {
        this.messages.forEach(message => {
            if (message.audioService !== undefined) {
                if (message.audioService.getAudio() !== undefined) {
                    message.audioService.getAudio()
                        .pause();
                }
            }
        });
        this.bsModalRef.hide();
    }

    @HostListener('document:keypress', ['$event'])
    keyEvent(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onClose();
        }
    }

    changeView(isPreview): void {
        this.isPreview = isPreview;
    }

    getJson(messageData: Array<any>): any {
        let jsonObj: any;
        const x2js = new X2JS();
        this.contentSource = messageData[0].message;
        // When a patient sends a confirm SMS we'll reply with "you have succesfully confirmed...".
        // We need to check if the contenttype="relation:reminder"
        if (this.mediaType === 'sms' && messageData.length > 1) {
            const messageItem = messageData.find(messageItem => Boolean(messageItem.message.match(/relation:reminder/g)));

            if (Boolean(messageItem)) {
                this.contentSource = messageItem.message;
            }
        }
        jsonObj = x2js.xml2js(this.contentSource);
        this.innerHtml = jsonObj.message !== undefined ? jsonObj.message.html : '';
        messageData.forEach(message => {
             message.audioService = new AudioService();

             return message;
            });
        this.messages = messageData;
        if (jsonObj.message === undefined && this.mediaType === 'sms') {
            jsonObj.message =  {'__text' : this.contentSource,
                                '_contenttype': 'relation:reminder',
                                 '_from': '',
                                 '_destinator': ''
                                };

        }

        return jsonObj;
    }
}
